import './styles/InvoiceCompanyItem.scss';

import { Button, Chip, Grid, Icon, Paper, Tooltip } from '@mui/material';
import { BillableCompany } from '@thro-types/jobmarket';

import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ErrorBoundary from 'app/components/ErrorBoundary';
import { Modal } from 'app/components/Modal';
import InvoiceDetail from 'app/containers/Jobmarket/InvoiceDetail';
import { translations } from 'locales/i18n';

interface Props {
  company: BillableCompany;
}

export const InvoiceCompanyItem: FunctionComponent<Props> = ({ company }) => {
  const { t } = useTranslation();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [disabledCancel, setDisabledCancel] = useState(false);

  return (
    <>
      <ErrorBoundary boundaryTag="invoiceDetailBoundary">
        <Modal
          open={createModalOpen}
          onClose={(event, reason) => {
            if (reason && reason === 'backdropClick') return;
            setCreateModalOpen(false);
          }}
          headline={t(translations.pages.invoices.create.title(), {
            company: company
          })}
          onCancel={() => {
            setCreateModalOpen(false);
          }}
          disabledCancel={disabledCancel}
        >
          <InvoiceDetail
            companyId={company.id}
            onCancel={() => setCreateModalOpen(false)}
            closeHandler={() => {
              setCreateModalOpen(false);
            }}
            setDisabledCancel={setDisabledCancel}
          />
        </Modal>
      </ErrorBoundary>
      <Grid container className="invoice-company-item">
        <Grid item xs={1} className="invoice-company-item__id">
          {company.id}
        </Grid>
        <Grid item xs={3} className="invoice-company-item__name">
          <a href={`/companies/${company.id}`} target="_blank" rel="noopener noreferrer">
            <Grid container>{company.name}</Grid>
          </a>
        </Grid>
        <Grid item xs={2} className="invoice-company-item__open-periods">
          <Chip
            component={Paper}
            icon={
              <Icon className="fas fa-briefcase" style={{ width: 'auto', marginLeft: '0.5em' }} />
            }
            label={company.openPeriods}
          />
        </Grid>
        <Grid item xs={2} className="invoice-company-item__earliest-period">
          <Chip
            component={Paper}
            icon={
              <Icon
                className="far fa-calendar-alt"
                style={{
                  width: 'auto',
                  marginLeft: '0.5em',
                  marginRight: '0'
                }}
              />
            }
            label={new Date(company.earliestPeriod!).toLocaleDateString()}
          />
        </Grid>
        <Grid item xs={2} className="invoice-company-item__open-amount">
          <Tooltip title="Netto" placement="top">
            <Chip
              className="invoice-company-item__open-amount--netto"
              component={Paper}
              icon={
                <Icon
                  className="fas fa-euro-sign"
                  style={{
                    width: 'auto',
                    marginLeft: '0.5em',
                    marginRight: '0'
                  }}
                />
              }
              label={company.openAmount?.toFixed(2)}
            />
          </Tooltip>
        </Grid>
        <Grid item xs={2} className="invoice-company-item__actions">
          <Button
            variant="contained"
            startIcon={
              <Icon
                className="fas fa-coins"
                style={{
                  width: 'auto',
                  marginLeft: '0.5em',
                  marginRight: '0'
                }}
              />
            }
            color="primary"
            onClick={() => setCreateModalOpen(true)}
          >
            {t(translations.pages.invoices.createInvoice())}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
